import AddIcon from "@mui/icons-material/Add";
import { Button, Grid, SxProps, Theme } from "@mui/material";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConditionField, DimensionDescriptor } from "../../../../../shared/reporting/api/biClient.types";
import DimensionSelection from "../../../../../shared/reporting/components/viewer/common/DimensionSelection.tsx";
import { selectDimensionsStructure } from "../../../../store/selectors/metaDataSelectors.ts";
import { createCurrentReportAction } from "../../../../store/utils/storeUtils";
import { createEmptyConditionItem } from "../utilities/createEmptyConditionItem";

interface Props {
  text: string;
  conditions: ConditionField[] | undefined;
  dimensions: DimensionDescriptor[];
  onAddField: (field: ConditionField) => void;
  sx?: SxProps<Theme>;
}

export default function AddCondition({ text, conditions, dimensions, onAddField, sx }: Props) {
  const dispatch = useDispatch();
  const dimensionsStructure = useSelector(selectDimensionsStructure);

  const [addConditionAnchorEl, setAddConditionAnchorEl] = useState<HTMLElement | null>(null);
  const [showAddConditions, setShowAddConditions] = useState(false);

  const conditionSelection = useMemo(() => {
    if (conditions === undefined) return dimensions;
    return dimensions.filter((f) => !conditions.some((fs) => f.name === fs.meta.name));
  }, [conditions, dimensions]);

  return (
    <Grid sx={sx} ref={setAddConditionAnchorEl}>
      <Button
        sx={{
          lineHeight: "20px",
          letterSpacing: "0.14px",
          fontSize: "12px",
          textWrap: "nowrap",
          height: "30px",
        }}
        startIcon={<AddIcon />}
        onClick={() => setShowAddConditions(true)}
      >
        {text}
      </Button>
      {addConditionAnchorEl && showAddConditions && (
        <DimensionSelection
          anchorEl={addConditionAnchorEl}
          dimensions={conditionSelection}
          onClose={(value) => {
            if (value !== undefined) {
              const field = createEmptyConditionItem(value);
              onAddField(field);
              dispatch(createCurrentReportAction("setAutoShowItemOptionsId", field.config.guid));
            }
            setShowAddConditions(false);
          }}
          menuWidth={addConditionAnchorEl.offsetWidth}
          dimensionsStructure={dimensionsStructure}
        />
      )}
    </Grid>
  );
}
